module.exports = __webpack_public_path__ + "assets/favicon-32x32.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/icons/favicon-32x32.png
// module id = 932
// module chunks = 17